//////////////////////////////////////////////////////////////////////
//
//  10/11/18
//  src/components/IconRow.js
//
//  This file is a single line of Icons in a Row.
//

import React, { Component } from "react";
import iMusic from "../images/iMusic.png";
import iHappy from "../images/iHappy.png";
import iNotes from "../images/iInfo.png";
import iFood  from "../images/iFood.png";
import ipadP  from "../images/iPadPortrait.png";
import ipadL  from "../images/iPadLandscape.png";
import iborP  from "../images/BlkBorder2Port.png";
import iborL  from "../images/BlkBorder2Land.png";
import "../containers/Main.css";
import "./IconRow.css";

class IconRow extends Component {
  //
  //  This will 'pop-up' a message when the icon is 'clicked' on.
  //
  popUp = ( icon, row ) => {
    console.log( "popUp " + icon );

    var id = "";

    switch( icon ) {
    case "music":     id="R1"+row;      break;
    case "food":      id="R2"+row;      break;
    case "happy":     id="R3"+row;      break;
    case "notes":     id="R4"+row;      break;
    default:          id="R2"+row;      break;
    }
    var popup = document.getElementById( id );
    popup.classList.toggle( "show" );
  }
  //
  //  I have the 'disabled' icons just 'grayed' out but they are
  //  still 'live' so I need to just do nothing when clicked.
  //
  dummy = () => { console.log( "disabled" ); }

  //
  //  This will render all the output.
  //
  render() {
    var { row, music, food, happy, notes, mpop, fpop, hpop, addr, type } = this.props;
    //
    // Note: This is how to setup an 'onClick' function with parameters.
    // Also Note: The first parameter 'this' does not get sent or is sent 'second' (not sure why right now).
    //
    var mtxt  = this.popUp.bind( this, "music", row );
    var ftxt  = this.popUp.bind( this, "food",  row );
    var htxt  = this.popUp.bind( this, "happy", row );
    var ntxt  = this.iPadPopUp.bind( this, "notes", addr, type );
    var dmy   = this.dummy.bind();

  //console.log( "IconRow" );
  //console.log( "Screen Width: " + this.state.width );

    return (
      <div className="IconRow">
        <span className="popup" onClick={ music ? mtxt : dmy }><span id={ "R1"+row } className="popuptxt">{ mpop }</span><img className={ music ? "showIcon" : "noIcon" } src={ iMusic } alt="Music"      /></span>
        <span className="popup" onClick={ food  ? ftxt : dmy }><span id={ "R2"+row } className="popuptxt">{ fpop }</span><img className={ food  ? "showIcon" : "noIcon" } src={ iFood  } alt="Food"       /></span>
        <span className="popup" onClick={ happy ? htxt : dmy }><span id={ "R3"+row } className="popuptxt">{ hpop }</span><img className={ happy ? "showIcon" : "noIcon" } src={ iHappy } alt="Happy Hour" /></span>
        <span className="popup" onClick={ notes ? ntxt : dmy }>
          <img className={ notes ? "showIcon" : "noIcon" } src={ iNotes } alt="More Info"  />
        </span>
      </div>
    );
  }

  ///////////////////////////////////////////////////////////
  //
  // When the user clicks on the button, open the modal 
  //
  iPadPopUp( icon, addr, top_type ) {
    console.log( "iPadPopUp" );

    // Pop-Up Info: (Pop-Ups are placed in front of Content)
    //  1) 'Pop-Up' - The container in which the popup content appears.
    //  2) 'Overlay' - The background rendered behind the popup and 'overlays' the site content.
    //  3) 'Content' - The actual size content that appears behind the overlay and the popup.

    //      Effect                                            Popup             Overlay           Content
    //      ------                                            -----             -------           -------
    //  1) Popup, overlay & content are each stationary       Stationary        Stationary        Does not scroll
    //  2) Popup and content scroll together                  Fixed Pos.        None              Scrollable
    //                                                        Popup moves with
    //                                                        content scroll.
    //  3) Popup is stationary. Content scrolls behind popup. Stationary        None              Scrollable, Content
    //                                                                                            scrolls behind popup.
    //  4)  Content scrolls inside popup content.             Stationary.       Set to either     Set to either
    //                                                        Content scrolls   stationary or     stationary or scrollable
    //                                                        inside popup.     none.

    switch( top_type ) {
    case "map":     document.getElementById( "MainMapTop" ).classList.add( "MainFreezeBkgnd" );       break;
    case "full":    document.getElementById( "MainFullTop" ).classList.add( "MainFreezeBkgnd" );      break;
    case "compact": document.getElementById( "MainCompactTop" ).classList.add( "MainFreezeBkgnd" );   break;
    default:        break;
    }

    document.getElementById( "myModal" ).innerHTML = "";
    /* We are trying to make this look like the following...
        <span id={ 'close' } style={ IRH_close } onclick={ cback }>&times;</span>
        <div  id={ 'myImg' } style={ IRH_myImg }></div>
    */

    var modal     = document.getElementById( "myModal" );
    var imgDiv    = document.createElement( 'div' );
    var closeSpan = document.createElement( 'span' );

    imgDiv.style.zIndex          = "5";
    imgDiv.style.height          = "50px";

    closeSpan.innerHTML          = "&times;";
    closeSpan.style.color        = "white";
    closeSpan.style.float        = "right";
    closeSpan.style.cursor       = "pointer";
    closeSpan.style.fontSize     = "4.0em";
    closeSpan.style.fontWeight   = "bold";
    closeSpan.style.zIndex       = "10";
    closeSpan.style.paddingRight = "20px";
    closeSpan.style.paddingLeft  = "20px";
    closeSpan.style.marginTop    = "-5px";
    closeSpan.addEventListener( "click", this.iPadClose.bind( null, top_type ) );

    modal.appendChild( closeSpan );
    modal.appendChild( imgDiv );

    var type = this.setiPad( addr );

    // Click on the button and open the image.
    if( type === "ipad" )        { modal.style.margin = "2% 10% 0 10%";   } 
    else if( type === "border" ) { modal.style.margin = "2% 5% 0 5%";     } 
    else                          { modal.style.margin = "2% 0";           } 

    modal.style.transition = "opacity linear 0.5s";
    modal.style.opacity    = "1.0";
    modal.style.visibility = "visible";

/***
    // Added 10/24/18 - 10:09
    // Added the following - this worked but there were the following problems:
    //  1 - There was no overlay (thus I could not 'close' because that button was not there).
    //  2 - The popup overflowed the bottom of the page and did not cutoff at the bottom of the border.
    //  3 - The popup did scroll, but the content did not (this is what I am trying to do).
    //
    modal.style.overflowY  = "scroll";
    modal.style.setProperty( "-webkit-overflow-scrolling", "touch" );

    // Added 10/24/18 - 10:09
    // Added just the class 'MainFreezeBkgnd' (without the below):
    //  1 - There was no overlay (thus I could not 'close' because that button was not there).
    //  2 - The popup did not scroll but the content did (not what I want).
    //
    //modal.style.overflowY  = "scroll";
    //modal.style.setProperty( "-webkit-overflow-scrolling", "touch" );

    // Added 10/24/18 - 10:10
    // Added the following - this is how it worked (:
    //  1 - There was an overlay (thus there was a 'close' button and I could close the popup).
    //  2 - The popup overflowed the bottom of the page and did not cutoff at the bottom of the border.
    //  3 - The popup did scroll, but the content did not (this is what I am trying to do).
    //
    //  Note: Added the following to 'Main.css': .MainFreezeBkgnd { position : fixed; width : 100%; }
    //
    modal.style.overflowY  = "scroll";
    modal.style.setProperty( "-webkit-overflow-scrolling", "touch" );

***/
    //
    // I am going to leave this as is for right now.
    //
    // This works 'kind of' how I want it to work.  The 'popup' does scroll and the 
    // background does not scroll.  So far this will work just to show as an example
    // of what the website will do and how it will work.  I pulled any image as a background
    // both the 'ipad' or the 'border image'.  I now only do the 'simple' border.
    //
    modal.style.overflow = "auto";
    modal.style.setProperty( "-webkit-overflow-scrolling", "touch" );
  }

  ///////////////////////////////////////////////////////////
  //
  // Now close the pop-up.
  //
  iPadClose( type, ev ) {
  console.log( "iPadClose, type = " + type );
//console.log( ev );

    switch( type ) {
    case "map":     document.getElementById( "MainMapTop" ).classList.remove( "MainFreezeBkgnd" );       break;
    case "full":    document.getElementById( "MainFullTop" ).classList.remove( "MainFreezeBkgnd" );      break;
    case "compact": document.getElementById( "MainCompactTop" ).classList.remove( "MainFreezeBkgnd" );   break;
    default:        break;
    }

    // Get the modal
    var modal = document.getElementById( "myModal" );
    modal.style.visibility = "hidden";
    modal.style.opacity = "0";
    
    // (this helped clear up a lot of issues in the mobile device.)
    modal.innerHTML = ""; // Now that it is hidden and opacity is '0'... delete 
  }

  ///////////////////////////////////////////////////////////
  //
  // This is how we initialize the popup for this page.
  // The display of this popup will be done in 3 ways.
  //
  //  1 - If we are on a desktop (over 1200px) then we will display the iPad view.
  //  2 - If we are between 1200px and 600px we will use a simple border.
  //  3 - If we are below 600px then we will just have a simple css border of "5px solid black"
  //
  setiPad( addr ) {
    // Get the modal
    var id_ipad = document.getElementById( "myModal" );

    var swidth = document.documentElement.clientWidth;  console.log( "Swidth: " + swidth );
    var width  = 0;         // Default to iPad display.
    var height = 0;         // Must be 0 to use iPad.
    var type   = "ipad";
    var land   = true;
    var landscape = ipadL;
    var portrait  = ipadP;

//  I have decided to pull the 'ipad' version which is what all the variables are defaulted to.
//  I like the full screen size of the 'border' outline.  The 'ipad' version was just too small
//  on the desktop and it didn't really look that much better than the 'border' version.
//  So, you see the 'ipad' defaults set above and I change the variables here without testing 
//  for the width of the screen anymore.
//    if( swidth < 1200 ) {
      console.log( "Set < 1200" );
      width     = Math.floor( swidth * 0.90 );
      type      = "border";
      landscape = iborL;
      portrait  = iborP;
      land      = false;

//  I have decided to also pull the border and just let the iframe generate its own border.
//  This way when the popup scrolls the border scrolls with it.
//  Maybe later we can try to change this method to make it look a bit better.
    //if( swidth < 600 ) {
        console.log( "Set < 600" );
        type      = "simple";  
        width     = swidth;
        landscape = "";
        portrait  = "";
    //}
      height    = Math.floor(( width * 4 ) / 3 );
      console.log( "Width: "  + width  );
      console.log( "Height: " + height );      
//  }

    this.ipad( id_ipad, type, {
      url    : addr,
      view   : ( land ) ? 'land' : 'front',
      width  : width,
      height : height,
      image  : ( land ) ? landscape : portrait
    })
    
    return type;
  }

  ///////////////////////////////////////////////////////////
  //
  //  biomp_ipad.js
  //
  //  This crazy script allows the user to see an iPad
  //  with a website running in it.
  //
  ipad( el, type, options ) {
  console.log( "Here 9, type: " + type );
  
    // Note: When you send in with width and height, this next line is not used.
    //       So, it does not matter what values are in here.  Without the width
    //       and height this is used.
    // Private, Note: This is the outside dimensions of the total image.
    var front = { width: 792, height: 1022, ratio: ( 792  / 1022 )},
        land  = { width: 1022, height: 792, ratio: ( 1022 / 792  )};

    // Options - Note: next line is go quiet a 'warning' we get during the 'compiling'.
    // The compiler does not like 'reusing' the word 'options'.
    // eslint-disable-next-line
    var options = options || {},
        url     = setOption( options.url,    ''      ),
        view    = setOption( options.view,   'front' ),
        image   = setOption( options.image,  ''      ),
        scale   = setOption( options.scale,  0       ),
        width   = setOption( options.width,  0       ),
        height  = setOption( options.height, 0       );

    function setOption( xoption, _default ) {
      return ( typeof xoption === 'undefined' ) ? _default : xoption;
    }

    function setSizes() {
      var selView = ( view === 'front' ) ? front : land;
      
      if( scale !== 0 ) {
        width  = ( selView.width  * scale );
        height = ( selView.height * scale );
      //console.log( "Here 3" );
        return;
      }

      if( width !== 0 ) {
        scale  = ( width / selView.width );
        height = ( width / selView.ratio );
      //console.log( "Here 4" );
        return;
      }

      if( height !== 0 ) {
        scale = ( height / selView.height );
        width = ( height * selView.ratio  );
      //console.log( "Here 5" );
        return;
      }

      scale  = 1;
      width  = selView.width;
      height = selView.height;
    //console.log( "Here 6" );
    }
      
    function create() {
      // Set view dimensions
      var selView = ( view === 'front' ) ? front : land;
    //console.log( "1) ",selView );

      // Set scrollbar CSS		
      var css = document.createTextNode(
        '.bio-mp-screen::-webkit-scrollbar {width: 6px; height: 6px;}' +
        '.bio-mp-screen::-webkit-scrollbar-track {background: none; -webkit-border-radius: 10px; border-radius: 10px;}' +
        '.bio-mp-screen::-webkit-scrollbar-thumb {-webkit-border-radius: 10px; border-radius: 10px; background: #777;}' +
        '.bio-mp-screen::-webkit-scrollbar-thumb:window-inactive {background: #777;}'
      );
    //console.log( "2) ",css );
      
      var style  = document.createElement( 'style' );
      style.type = 'text/css';
      style.appendChild( css );
    //console.log( "3) ",style );
      
      // Add phone div
      var phone = document.createElement( 'div' );
      el.appendChild( phone );
    //console.log( "4) ",phone );

      // Add phone image
      if( image !== "" ) {
        var phoneImage = document.createElement( 'img' );
        phoneImage.src = image;
        phone.appendChild( phoneImage );
    //console.log( "5) ",image );
      }
      
      // Add iframe
      var iframe = document.createElement( 'iframe' );
      iframe.src = url;
      iframe.className = 'ipad-mp-screen';
      phone.appendChild( iframe );
    //console.log( "6) ",iframe );
    //console.log( "7) ",url );

      // Add CSS
      var wrapCss       = 'width: ' + width + 'px; height: ' + height + 'px; overflow: hidden; transform-origin: 0 0 0;';
      var phoneCss      = 'position: relative; top: 0px; left: 0px; width: ' + selView.width + 'px; height: ' + selView.height + 'px; background: none; -webkit-transform-origin: 0 0 0; -moz-transform-origin: 0 0 0; -ms-transform-origin: 0 0 0; -o-transform-origin: 0 0 0; transform-origin: 0 0 0; -webkit-transform: scale(' + scale + '); -moz-transform: scale(' + scale + '); -ms-transform: scale(' + scale + '); -o-transform: scale(' + scale + '); transform: scale(' + scale + ');';
      var phoneImageCss = 'position: absolute; top: 0; left: 0; width: 100%; height: 100%;';
    //console.log( "8) ",wrapCss );
    //console.log( "9) ",phoneCss );
    //console.log( "10) ",phoneImageCss );

      var screenCss = '';

      if( view === 'front' ) {
console.log( "Type: " + type );
        if( type === 'ipad' ) {
console.log( "ipad: " + type ); // I think I have pulled 'ipad'... now I just use 'border' or 'simple'.
          //top = top left, left = top left, width = width of inside window, height = height of inside window.
          screenCss = 'position: absolute; top: 114px; left: 93px; width: 615px; height: 818px; border: 0;';
        } else if( type === 'border' ) {
console.log( "border: " + type );
         	screenCss = 'position: absolute; top: 30px; left: 29px; width: 727px; height: 964px; border: 0';
        } else {
console.log( "simple: " + type );
         	screenCss = 'position: absolute; top: 30px; left: 29px; width: 727px; height: 964px; border: 5px solid white;';
        }
      } else {
      //var screenCss = 'position: absolute; top: 135px; left: -13px; width: 375px; height: 669px; border: 0; -webkit-transform: matrix3d(0.682, 0.160, 0, 0.000380, 0, 0.972, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); -moz-transform: matrix3d(0.682, 0.160, 0, 0.000380, 0, 0.972, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); -ms-transform: matrix3d(0.682, 0.160, 0, 0.000380, 0, 0.972, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); -o-transform: matrix3d(0.682, 0.160, 0, 0.000380, 0, 0.972, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform: matrix3d(0.682, 0.160, 0, 0.000380, 0, 0.972, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);';
      //top = top left, left = top left, width = width of inside window, height = height of inside window.
console.log( "Back Type: " + type );  // I think I ALWAYS set 'view' to front.
        screenCss = 'position: absolute; top: 83px; left: 113px; width: 820px; height: 617px; border: 0;';
      }
    //console.log( "11) ",screenCss );

      el.style.cssText        += wrapCss;
      phone.style.cssText      = phoneCss;
      if( image !== "" ) {  phoneImage.style.cssText = phoneImageCss;   }
    //                      phoneImage.style.cssText = phoneImageCss;
      iframe.style.cssText     = screenCss;
      
      // Add scrollbar CSS above the wrap
      el.parentNode.insertBefore( style, el );
    //console.log( "Here 2" );
    }

    //console.log( "Here 1" );
    // Init
    setSizes();
    create();
  }
}

export default IconRow;



// WEBPACK FOOTER //
// ./src/components/IconRow.js